/** ブレークポイント（この幅以内がモバイル向けとなる） */
export const BREAK_POINT = 768;
// 以下のファイルにも同じ値を設定すること
// - _defs.scss
// - config.yml

export const IS_ACTIVE = "is-active";

export const MENU_DURATION = 0.3;
